var whaValidate = {

	outputData: {},
	inputData: {},

	init: function() {
		var target = document.querySelector('[data-whavalidator-container]') || null;
		if (null !== target) {
			whaValidate.initDomElements(target);
			whaValidate.initData();
			whaValidate.initEvents();
		}
	},

	initDomElements: function(target) {
		whaValidate.elTableWha = target.querySelector('[data-table-wha]');
		whaValidate.elTableAo = target.querySelector('[data-table-ao]');
		whaValidate.elTableResult = target.querySelector('[data-table-result]');
		whaValidate.elDataFieldInput = target.querySelector('[data-whaValidator-data-input]');
		whaValidate.elDataFieldOutput = target.querySelector('[data-whaValidator-data-output]');
	},

	initData: function() {
		whaValidate.inputData = whaValidate.getInputData(whaValidate.elDataFieldInput);
		whaValidate.outputData = whaValidate.getInputData(whaValidate.elDataFieldInput);
		whaValidate.applyInputToDom('werknemer_melding_werkhervattingspercentage', whaValidate.elTableWha);
		whaValidate.applyInputToDom('werknemer_melding_aopercentage', whaValidate.elTableAo);
		whaValidate.elDataFieldOutput.value = JSON.stringify(whaValidate.inputData);
		whaValidate.applyOutputDataToDom();
	},

	initEvents: function() {
		document.addEventListener('click', function(event) {
			for (var target = event.target; target && target != this; target = target.parentNode) {
				if (target.matches('[data-table-wha] tbody tr, [data-table-ao] tbody tr')) {
					whaValidate.toggleRowState(event.target);
					whaValidate.uncheckDuplicate(event.target);
					whaValidate.applyDomSelectionToOutputData();
					whaValidate.applyOutputDataToDom();
					break;
				}
			}
		}, false);
	},

	uncheckDuplicate: function(target) {
		var checkbox = target.parentNode.querySelector('input[type=checkbox]');
		if (checkbox !== null) {
			var date = checkbox.getAttribute('data-date');
			var type = checkbox.getAttribute('data-type');
			if (type == 'werknemer_melding_werkhervattingspercentage') {
				target = whaValidate.elTableAo.querySelector('input[type=checkbox][data-date="' + date + '"]');
			} else if (type == 'werknemer_melding_aopercentage') {
				target = whaValidate.elTableWha.querySelector('input[type=checkbox][data-date="' + date + '"]');
			}
			if (target !== null) {
				target.checked = false;
				whaValidate.toggleSignal(target);
			}
		}
	},

	getInputData: function(target) {
		var dataElement = target;
		if (dataElement) {
			var jsonString = dataElement.value;
			var object = JSON.parse(jsonString);
			return object;
		}
	},

	applyInputToDom: function(type, target) {
		var rowTemplate = target.querySelector('[data-tr-template]');
		var tableBody = target.querySelector('tbody');
		var werknemer_melding_id = '';
		for (let [date, content] of Object.entries(whaValidate.inputData)) {

			if (content['werknemer_melding_id'] !== werknemer_melding_id && werknemer_melding_id !== '') {
				var emptyClone = rowTemplate.cloneNode(true);
				emptyClone.querySelector('[data-tr-template-check]').innerHTML = '';
				emptyClone.classList.add('bg-disabled');
				emptyClone.classList.remove('d-none');
				tableBody.appendChild(emptyClone);
			}
			werknemer_melding_id = content['werknemer_melding_id'];

			var clone = rowTemplate.cloneNode(true);

			if (content[type] !== undefined) {
				clone.setAttribute('data-type', type);
				clone.setAttribute('data-tr-row', 'true');
				clone.removeAttribute('data-tr-template');
				clone.querySelector('[data-tr-template-date]').innerHTML = date;
				clone.querySelector('[data-tr-template-percentage]').innerHTML = content[type]['oapercentage'];
				clone.querySelector('[data-tr-template-checkbox]').checked = content[type]['selected'];
				clone.querySelector('[data-tr-template-checkbox]').disabled = content[type]['protected'];
				clone.querySelector('[data-tr-template-checkbox]').setAttribute('data-date', date);
				clone.querySelector('[data-tr-template-checkbox]').setAttribute('data-type', type);
				whaValidate.toggleSignal(clone.querySelector('[data-tr-template-checkbox]'));
			} else {
				clone.querySelector('[data-tr-template-check]').innerHTML = '&nbsp;';
			}
			clone.classList.remove('d-none');
			tableBody.appendChild(clone);
		}
	},

	toggleRowState: function(target) {
		var row = target.parentNode;
		var checkbox = row.querySelector('input[type=checkbox]');
		if (checkbox !== null) {
			var disabled = checkbox.disabled;
			if (!disabled) {
				checkbox.checked = !checkbox.checked;
				whaValidate.toggleSignal(checkbox);
			}
		}
	},

	toggleSignal: function(target) {
		var row = target.parentNode.parentNode;
		row.classList.add('table-success');
		if (!target.checked) {
			row.classList.remove('table-success');
		}
	},

	clearSelection: function() {
		for (let [date, content] of Object.entries(whaValidate.outputData)) {
			for (let [key] of Object.entries(content)) {
				if (typeof whaValidate.outputData[date][key] !== 'object') {
					whaValidate.outputData[date][key] = {};
				}
				whaValidate.outputData[date][key]['selected'] = false;
			}
		}
	},

	applyDomSelectionToOutputData: function() {
		whaValidate.clearSelection();
		['elTableWha', 'elTableAo'].forEach(function(table) {
			whaValidate[table].querySelectorAll('input[type=checkbox]:checked').forEach(function(element) {
				var date = element.getAttribute('data-date');
				var type = element.getAttribute('data-type');
				// console.log(date);
				// console.log(type);
				whaValidate.outputData[date][type]['selected'] = true;
			});
		});
		whaValidate.elDataFieldOutput.value = JSON.stringify(whaValidate.outputData);
	},

	applyOutputDataToDom: function() {
		var tableBody = whaValidate.elTableResult.querySelector('tbody');
		var rowTemplate = whaValidate.elTableResult.querySelector('[data-tr-template]');
		var werknemer_melding_id = '';
		tableBody.innerHTML = '';
		for (let [date, content] of Object.entries(whaValidate.outputData)) {
			var clone = rowTemplate.cloneNode(true);
			clone.querySelectorAll('[data-tr-template-date], [data-tr-template-percentage], [data-tr-template-type]').forEach(el => el.innerHTML = '&nbsp;');
			for (let [key, value] of Object.entries(content)) {

				if (content['werknemer_melding_id'] !== werknemer_melding_id && werknemer_melding_id !== '') {
					var emptyClone = rowTemplate.cloneNode(true);
					emptyClone.querySelectorAll('[data-tr-template-date], [data-tr-template-percentage], [data-tr-template-type]').forEach(el => el.innerHTML = '');
					emptyClone.querySelector('[data-tr-template-type]').innerHTML = '';
					emptyClone.classList.add('bg-disabled');
					emptyClone.classList.remove('d-none');
					tableBody.appendChild(emptyClone);
				}
				werknemer_melding_id = content['werknemer_melding_id'];

				if (value.selected != undefined && value.selected == true) {
					clone.querySelector('[data-tr-template-date]').innerHTML = date;
					clone.querySelector('[data-tr-template-percentage]').innerHTML = value['oapercentage'];
					clone.querySelector('[data-tr-template-type]').innerHTML = (key == 'werknemer_melding_aopercentage' ? 'AO %' : 'WHA %');
				}
			}
			clone.classList.remove('d-none');
			tableBody.appendChild(clone);
		}
	}

};

export default whaValidate;
